// Copyright (c) 2017 Deere & Company

import LaborRateChangeContainer from '../../tcsm/labor-rate-approval/state-connector';

export default {
    component: LaborRateChangeContainer,
    path: 'labor-rates/:account'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/labor-rate-approval.js